export enum SectionType {
  NEWS = 'news',
  UPDATE_NEWS = 'updateNews',
  FAQ = 'faq',
  UPDATE_FAQ = 'updateFaq',
  TASK = 'task',
  UPDATE_TASK = 'updateTask',
  CLUB = 'club',
  TAG = 'tag',
  ROOM = 'room',
  UPDATE_ROOM = 'updateRoom',
  INSTRUCTOR = 'instructor',
  UPDATE_INSTRUCTOR = 'updateInstructor',
  COURSE = 'course',
  UPDATE_COURSE = 'updateCourse',
  GROUP = 'group',
  UPDATE_GROUP = 'updateGroup',
  BANNER = 'banner',
  EVENT = 'event',
  UPDATE_EVENT = 'updateEvent',
  QR_CODE = 'userQRCode',
  SURVEY = 'survey',
  EVENT_SHIFT = 'eventShift',
  PROFILE = 'profile', // to be used in alert message in profile edit screen
  BANK_DETAILS = 'bankDetails', // to be used in alert message in profile > bank details screen
}
